/* =====================================================================
   QR-noutopyyntopilotti — assets/qr-pickup.js
   Ladataan SIVUSTONLAAJUISESTI (layout/theme.liquid), jotta noutotila
   pysyy paalla ja OIKEA Shopify-ostoskori/kassa pysyy estettyna joka
   ikisella sivulla — ei vain kokoelmasivulla — kunnes asiakas itse
   painaa "Siirry verkkokauppaan" -linkkia (tyhjentaa noutotilan).
   Kaikki Toivekori-tila pidetaan sessionStorage/localStorage-avaimissa
   selaimen puolella, ei koskaan Shopifyn omassa ostoskorissa.
   ===================================================================== */
(function () {
  'use strict';

  var STORAGE_PICKUP = 'kjQrPickup';
  var STORAGE_ITEMS = 'kjToivekori';
  var VALID_PICKUPS = ['combo', 'sepankyla', 'comboliina'];

  function safeGet(storage, key) {
    try {
      return storage.getItem(key);
    } catch (e) {
      return null;
    }
  }

  function safeSet(storage, key, value) {
    try {
      storage.setItem(key, value);
    } catch (e) {
      /* yksityinen selaus tms. — ei kriittista, jatketaan ilman tallennusta */
    }
  }

  function safeRemove(storage, key) {
    try {
      storage.removeItem(key);
    } catch (e) {}
  }

  function loadItems() {
    var raw = safeGet(window.localStorage, STORAGE_ITEMS);
    if (!raw) return [];
    try {
      var parsed = JSON.parse(raw);
      return Array.isArray(parsed) ? parsed : [];
    } catch (e) {
      return [];
    }
  }

  function saveItems(items) {
    safeSet(window.localStorage, STORAGE_ITEMS, JSON.stringify(items));
  }

  function findIndexById(items, id) {
    for (var i = 0; i < items.length; i++) {
      if (items[i].id === id) return i;
    }
    return -1;
  }

  /* ---------------------------------------------------------------
     1. Tunnista QR-tila: ensin URL-parametri, sitten istuntomuisti.
     Jos kumpaakaan ei loydy, sivu nakyy taysin normaalina — mitaan
     QR-elementtia ei koskaan aktivoida.
     --------------------------------------------------------------- */
  var params = new URLSearchParams(window.location.search);
  var paramPickup = params.get('pickup');
  var pickup = null;

  if (VALID_PICKUPS.indexOf(paramPickup) !== -1) {
    pickup = paramPickup;
    safeSet(window.sessionStorage, STORAGE_PICKUP, pickup);
  } else {
    var stored = safeGet(window.sessionStorage, STORAGE_PICKUP);
    if (VALID_PICKUPS.indexOf(stored) !== -1) {
      pickup = stored;
    }
  }

  if (!pickup) {
    /* Normaali kavija: ei tehda mitaan. */
    return;
  }

  var LOCATION_LABELS = {
    combo: 'Combo (Vaasa)',
    sepankyla: 'Sepänkylä (saat osoitteen, kun noutotilaus on vahvistettu)',
    comboliina: 'Comboliina'
  };

  var initialized = false;

  if (document.readyState === 'interactive' || document.readyState === 'complete') {
    init();
  } else {
    document.addEventListener('DOMContentLoaded', init);
  }

  function init() {
    if (initialized) return;
    initialized = true;

    document.body.classList.add('kj-qr-active');

    ensureTopBanner();
    applyPickupUI();
    filterCollectionGrid();
    renderAll();
    blockRealCheckout();
    insertProductPageNotice();
    /* Toinen renderointikierros insertProductPageNotice():n jalkeen, jotta
       juuri lisatty tuotesivun Toivekoriin-painike saa heti oikean tilansa
       ("Toivekorissa" jos tuote on jo listalla). */
    renderAll();
    wireEvents();

    /* Varmuuden vuoksi viela yksi tarkistuskierros pian sen jalkeen kun
       sivu on kokonaan valmis — jos jokin ostoskori-elementti (esim.
       hidastetusti latautuva sovellus tai variantin vaihto) ilmestyy
       DOMiin viela init()-kutsun jalkeen, se piilotetaan silti. */
    setTimeout(function () {
      filterCollectionGrid();
      blockRealCheckout();
      insertProductPageNotice();
      renderAll();
    }, 700);

    if (window.KJ_QR_POSTED === true) {
      saveItems([]);
      renderAll();
      openDrawer();
      showSuccessView();
    }
  }

  /* ---------------------------------------------------------------
     1c. Sivunlaajuinen OIKEAN ostoskorin/kassan esto. Noutotilassa
     asiakas saa AINOASTAAN lisata tuotteita Toivekoriin — ei koskaan
     oikeaa Shopify-ostoskoria tai kassaa. Tama koskee JOKAISTA sivua,
     ei vain kokoelmasivua, koska noutotila sailyy istunnon ajan.
     --------------------------------------------------------------- */
  function getCartUrl() {
    return (window.routes && window.routes.cart_url) || '/cart';
  }

  function blockRealCheckout() {
    /* Piilota tuotesivun/pika-lisayksen "Lisaa ostoskoriin" -lomakkeet
       ja niiden mahdolliset dynaamiset kassapainikkeet (Shop Pay yms). */
    var forms = document.querySelectorAll('form[data-type="add-to-cart-form"]');
    for (var i = 0; i < forms.length; i++) {
      var wrapper = forms[i].closest('product-form') || forms[i];
      if (wrapper.getAttribute('data-kj-blocked') === 'true') continue;
      wrapper.setAttribute('data-kj-blocked', 'true');
      wrapper.style.display = 'none';
    }

    var payButtons = document.querySelectorAll('.shopify-payment-button');
    for (var p = 0; p < payButtons.length; p++) {
      payButtons[p].style.display = 'none';
    }

    /* Piilota ostoskorikuvake/-linkki ylatunnisteesta ja kaikki
       kassalinkit, jotta vanhaan ostoskoriin tai kassalle ei paase
       mitaan muuta kautta. */
    var cartUrl = getCartUrl();
    var cartLinks = document.querySelectorAll('a[href="' + cartUrl + '"], a[href*="/checkout"]');
    for (var c = 0; c < cartLinks.length; c++) {
      cartLinks[c].style.display = 'none';
    }

    var checkoutButtons = document.querySelectorAll('button[name="checkout"]');
    for (var k = 0; k < checkoutButtons.length; k++) {
      checkoutButtons[k].style.display = 'none';
    }
  }

  /* ---------------------------------------------------------------
     1d. Tuotesivun korvaava sisalto: kun oikea "Lisaa ostoskoriin"
     -lomake on piilotettu, nayta sen tilalla joko Toivekoriin-painike
     (jos tuote on Vaasasta/Comboliinasta noudettavissa) tai viesti,
     etta tuotetta ei voi juuri nyt hakea paikan paalta.
     --------------------------------------------------------------- */
  function insertProductPageNotice() {
    if (!window.KJ_QR_PRODUCT) return;
    if (document.getElementById('KjQrProductNotice')) return;

    var forms = document.querySelectorAll('form[data-type="add-to-cart-form"]');
    if (forms.length === 0) return;
    var anchor = forms[0].closest('product-form') || forms[0];
    if (!anchor || !anchor.parentNode) return;

    var notice = document.createElement('div');
    notice.id = 'KjQrProductNotice';
    notice.className = 'kj-qr-product-notice';

    if (window.KJ_QR_PRODUCT.vaasaEligible && window.KJ_QR_PRODUCT.available) {
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'kj-qr-toivekori-btn kj-qr-toivekori-btn--product';
      btn.setAttribute('data-id', window.KJ_QR_PRODUCT.id);
      btn.setAttribute('data-handle', window.KJ_QR_PRODUCT.handle);
      btn.setAttribute('data-title', window.KJ_QR_PRODUCT.title);
      btn.setAttribute('data-price', window.KJ_QR_PRODUCT.price);
      btn.setAttribute('data-image', window.KJ_QR_PRODUCT.image);
      btn.setAttribute('aria-label', 'Lisaa ' + window.KJ_QR_PRODUCT.title + ' Toivekoriin');
      btn.innerHTML =
        '<span class="kj-qr-heart" aria-hidden="true">&#9825;</span>' +
        '<span class="kj-qr-label">Toivekoriin</span>';
      notice.appendChild(btn);

      var p1 = document.createElement('p');
      p1.className = 'kj-qr-product-notice__text';
      p1.textContent =
        'Tuotetta ei voi ostaa suoraan talta sivulta noutopyynnon aikana. Lisaa se Toivekoriin, niin voit pyytaa sen noutoon.';
      notice.appendChild(p1);
    } else {
      var p2 = document.createElement('p');
      p2.className = 'kj-qr-product-notice__text';
      p2.textContent =
        'Tama tuote ei ole juuri nyt noudettavissa paikan paalta. Tilaa se sen sijaan verkkokaupasta ylhaalta poistumislinkista.';
      notice.appendChild(p2);
    }

    /* Ei omaa poistumislinkkia tassa — sivun ylapalkissa (tai isossa
       kokoelmasivun bannerissa) on jo yksi "Siirry verkkokauppaan"
       -linkki, eika kahta samaa linkkia haluta paallekkain. */

    anchor.parentNode.insertBefore(notice, anchor.nextSibling);
  }

  /* ---------------------------------------------------------------
     1e. Sivunlaajuinen ylapalkki: nayttaa noutotilan ja poistumislinkin
     JOKAISELLA sivulla. Jos sivulla on jo iso kokoelmasivun banneri
     (#KjQrBanner), ylapalkkia ei lisata paallekkain.
     --------------------------------------------------------------- */
  function ensureTopBanner() {
    if (document.getElementById('KjQrBanner')) return;
    if (document.getElementById('KjQrTopbar')) return;
    if (!document.body) return;

    var bar = document.createElement('div');
    bar.id = 'KjQrTopbar';
    bar.className = 'kj-qr-topbar';

    var label = document.createElement('span');
    label.id = 'KjQrTopbarLabel';
    label.className = 'kj-qr-topbar__label';
    bar.appendChild(label);

    var exit = document.createElement('a');
    exit.href = '/';
    exit.className = 'kj-qr-topbar__link kj-qr-exit-link';
    exit.textContent = 'Siirry verkkokauppaan';
    bar.appendChild(exit);

    document.body.insertBefore(bar, document.body.firstChild);
  }

  /* ---------------------------------------------------------------
     1f. Kokoelmalistauksen suodatus: noutotilan aikana asiakas ei saa
     nahda ollenkaan tuotteita, joita ei voi noutaa 1-2 paivan sisalla —
     eli tuotteita, jotka eivat ole taggattu "Noudettavissa Vaasasta"
     TAI jotka ovat loppuunmyytyja. Nama piilotetaan kokonaan kortteina,
     ei vain ilman Toivekori-mahdollisuutta. Palautuvat nakyviin itsestaan
     heti kun tuote taggataan tai saa varastoa (data luetaan joka
     sivunlatauksella suoraan Shopifysta, ei tarvitse paivittaa mitaan
     kasin). --------------------------------------------------------- */
  function filterCollectionGrid() {
    var items = document.querySelectorAll('.kj-qr-item');
    if (items.length === 0) return;

    var visibleCount = 0;
    for (var i = 0; i < items.length; i++) {
      var li = items[i];
      var isVaasa = li.classList.contains('kj-qr-item--vaasa');
      var isAvailable = li.getAttribute('data-kj-available') === 'true';
      var eligible = isVaasa && isAvailable;
      li.style.display = eligible ? '' : 'none';
      if (eligible) visibleCount++;
    }

    var countEl = document.getElementById('ProductCountDesktop');
    if (countEl) {
      countEl.textContent = visibleCount + ' juuri nyt noudettavissa';
    }
  }

  /* ---------------------------------------------------------------
     1b. Noutopaikan valinta: paivittaa bannerin, "Noutopaikka"-tekstin,
     piilokentan ja radiopainikkeet aina, kun pickup vaihtuu — joko
     sivun latautuessa (QR-koodin mukaan) tai kun asiakas itse
     vaihtaa valintaa lomakkeessa.
     --------------------------------------------------------------- */
  function applyPickupUI() {
    document.body.setAttribute('data-kj-pickup', pickup);

    var banners = document.querySelectorAll('.kj-qr-banner__text');
    for (var b = 0; b < banners.length; b++) {
      var isMatch = banners[b].getAttribute('data-pickup') === pickup;
      banners[b].classList.toggle('kj-qr-visible', isMatch);
    }

    var pickupReadout = document.getElementById('KjQrPickupReadout');
    if (pickupReadout) {
      pickupReadout.textContent = 'Noutopaikka: ' + LOCATION_LABELS[pickup];
    }

    var topbarLabel = document.getElementById('KjQrTopbarLabel');
    if (topbarLabel) {
      topbarLabel.textContent =
        'Noutopyyntotila: ' + LOCATION_LABELS[pickup] + ' — tuotteita ei voi ostaa suoraan, vain lisata Toivekoriin.';
    }

    var hiddenPickup = document.getElementById('KjQrHiddenPickup');
    if (hiddenPickup) {
      hiddenPickup.value = LOCATION_LABELS[pickup];
    }

    var choiceInputs = document.querySelectorAll('input[name="kjPickupChoice"]');
    for (var c = 0; c < choiceInputs.length; c++) {
      var input = choiceInputs[c];
      var checked = input.value === pickup;
      input.checked = checked;
      var option = input.closest('.kj-qr-pickup-choice__option');
      if (option) option.classList.toggle('kj-qr-selected', checked);
    }
  }

  /* ---------------------------------------------------------------
     2. Renderointi
     --------------------------------------------------------------- */
  function renderAll() {
    var items = loadItems();
    renderFab(items);
    renderList(items);
    updateButtonStates(items);
  }

  function renderFab(items) {
    var fab = document.getElementById('KjQrFab');
    var count = document.getElementById('KjQrFabCount');
    if (!fab || !count) return;
    count.textContent = String(items.length);
  }

  function renderList(items) {
    var list = document.getElementById('KjQrList');
    var empty = document.getElementById('KjQrEmpty');
    var gotoFormBtn = document.getElementById('KjQrGotoForm');
    if (!list || !empty) return;

    list.innerHTML = '';

    if (items.length === 0) {
      empty.classList.add('kj-qr-visible');
      if (gotoFormBtn) gotoFormBtn.disabled = true;
      return;
    }

    empty.classList.remove('kj-qr-visible');
    if (gotoFormBtn) gotoFormBtn.disabled = false;

    items.forEach(function (item) {
      var li = document.createElement('li');

      var img = document.createElement('img');
      img.src = item.image || '';
      img.alt = '';
      img.loading = 'lazy';
      li.appendChild(img);

      var info = document.createElement('div');
      info.className = 'kj-qr-list__info';

      var title = document.createElement('span');
      title.className = 'kj-qr-list__title';
      title.textContent = item.title || '';
      info.appendChild(title);

      var price = document.createElement('span');
      price.className = 'kj-qr-list__price';
      price.textContent = item.price || '';
      info.appendChild(price);

      li.appendChild(info);

      var removeBtn = document.createElement('button');
      removeBtn.type = 'button';
      removeBtn.className = 'kj-qr-list__remove';
      removeBtn.setAttribute('data-kj-remove-id', item.id);
      removeBtn.setAttribute('aria-label', 'Poista Toivekorista');
      removeBtn.textContent = '×';
      li.appendChild(removeBtn);

      list.appendChild(li);
    });
  }

  function updateButtonStates(items) {
    var buttons = document.querySelectorAll('.kj-qr-toivekori-btn');
    for (var i = 0; i < buttons.length; i++) {
      var btn = buttons[i];
      var id = btn.getAttribute('data-id');
      var inList = findIndexById(items, id) !== -1;
      btn.classList.toggle('kj-qr-in-list', inList);
      var label = btn.querySelector('.kj-qr-label');
      if (label) {
        label.textContent = inList ? 'Toivekorissa' : 'Toivekoriin';
      }
    }
  }

  /* ---------------------------------------------------------------
     3. Toivekorin lisays/poisto
     --------------------------------------------------------------- */
  function toggleItemFromButton(btn) {
    var id = btn.getAttribute('data-id');
    var items = loadItems();
    var idx = findIndexById(items, id);

    if (idx !== -1) {
      items.splice(idx, 1);
    } else {
      items.push({
        id: id,
        handle: btn.getAttribute('data-handle') || '',
        title: btn.getAttribute('data-title') || '',
        price: btn.getAttribute('data-price') || '',
        image: btn.getAttribute('data-image') || ''
      });
    }

    saveItems(items);
    renderAll();
  }

  function removeItemById(id) {
    var items = loadItems();
    var idx = findIndexById(items, id);
    if (idx !== -1) {
      items.splice(idx, 1);
      saveItems(items);
      renderAll();
    }
  }

  /* ---------------------------------------------------------------
     4. Paneelin (drawer) avaus/sulku ja nakymanvaihto
     --------------------------------------------------------------- */
  function openDrawer() {
    var overlay = document.getElementById('KjQrDrawerOverlay');
    var drawer = document.getElementById('KjQrDrawer');
    if (overlay) overlay.classList.add('kj-qr-open');
    if (drawer) drawer.classList.add('kj-qr-open');
    showListView();
  }

  function closeDrawer() {
    var overlay = document.getElementById('KjQrDrawerOverlay');
    var drawer = document.getElementById('KjQrDrawer');
    if (overlay) overlay.classList.remove('kj-qr-open');
    if (drawer) drawer.classList.remove('kj-qr-open');
  }

  function showListView() {
    var listView = document.getElementById('KjQrListView');
    var formView = document.getElementById('KjQrFormView');
    var successView = document.getElementById('KjQrSuccessView');
    var footer = document.getElementById('KjQrListFooter');
    if (listView) listView.classList.remove('kj-qr-hidden');
    if (formView) formView.classList.remove('kj-qr-visible');
    if (successView) successView.classList.remove('kj-qr-visible');
    if (footer) footer.classList.remove('kj-qr-hidden');
  }

  function showFormView() {
    var items = loadItems();
    if (items.length === 0) return;
    var listView = document.getElementById('KjQrListView');
    var formView = document.getElementById('KjQrFormView');
    var footer = document.getElementById('KjQrListFooter');
    if (listView) listView.classList.add('kj-qr-hidden');
    if (formView) formView.classList.add('kj-qr-visible');
    if (footer) footer.classList.add('kj-qr-hidden');
  }

  function showSuccessView() {
    var listView = document.getElementById('KjQrListView');
    var formView = document.getElementById('KjQrFormView');
    var successView = document.getElementById('KjQrSuccessView');
    var footer = document.getElementById('KjQrListFooter');
    if (listView) listView.classList.add('kj-qr-hidden');
    if (formView) formView.classList.remove('kj-qr-visible');
    if (successView) successView.classList.add('kj-qr-visible');
    if (footer) footer.classList.add('kj-qr-hidden');
  }

  /* ---------------------------------------------------------------
     5. Lomakkeen validointi ja lahetys
     --------------------------------------------------------------- */
  function validateAndFillForm(form) {
    var items = loadItems();
    var itemsError = document.getElementById('KjQrItemsError');
    var contactError = document.getElementById('KjQrContactError');
    var nameField = document.getElementById('KjQrName');
    var emailField = document.getElementById('KjQrEmail');
    var phoneField = document.getElementById('KjQrPhone');

    var valid = true;

    if (items.length === 0) {
      if (itemsError) itemsError.classList.add('kj-qr-visible');
      valid = false;
    } else if (itemsError) {
      itemsError.classList.remove('kj-qr-visible');
    }

    var hasName = nameField && nameField.value.trim().length > 0;
    var hasEmail = emailField && emailField.value.trim().length > 0;
    var hasPhone = phoneField && phoneField.value.trim().length > 0;

    if (!hasName || (!hasEmail && !hasPhone)) {
      if (contactError) contactError.classList.add('kj-qr-visible');
      valid = false;
    } else if (contactError) {
      contactError.classList.remove('kj-qr-visible');
    }

    if (!valid) return false;

    /* KJ QR: Shopifyn oma yhteydenottolomake (form 'contact') vaatii AINA
       kentan contact[email], tai lomake ei mene lapi lainkaan Shopifyn
       puolella - tama on Shopifyn oma, pakollinen saanto, eika liity
       taman lomakkeen omaan "nimi + puhelin TAI sahkoposti" -saantoon.
       Jos asiakas on antanut vain puhelinnumeron, taytetaan sahkoposti-
       kenttaan nakymaton, muotoiltu paikkamerkki-osoite juuri ennen
       lahetysta, jotta Shopify hyvaksyy lomakkeen ja Kulttijuliste saa
       viestin perille - oikea puhelinnumero kulkee joka tapauksessa
       mukana omassa contact[Puhelin]-kentassaan. */
    if (!hasEmail && hasPhone && emailField) {
      var phoneDigits = phoneField.value.replace(/[^0-9]/g, '') || 'tuntematon';
      emailField.value = 'puhelinasiakas-' + phoneDigits + '@kulttijuliste.fi';
    }

    var hiddenPickup = document.getElementById('KjQrHiddenPickup');
    var hiddenProducts = document.getElementById('KjQrHiddenProducts');

    if (hiddenPickup) hiddenPickup.value = LOCATION_LABELS[pickup];

    if (hiddenProducts) {
      var lines = items.map(function (item) {
        return '- ' + item.title + ' (' + item.price + ')';
      });
      hiddenProducts.value = lines.join('\n');
    }

    return true;
  }

  /* ---------------------------------------------------------------
     6. Tapahtumasidonnat
     --------------------------------------------------------------- */
  function wireEvents() {
    /* Varmuuden vuoksi: jos jokin "Lisaa ostoskoriin"- tai kassalomake
       paatyy silti lahetettavaksi (esim. juuri ennen kuin JS ehtii
       piilottaa sen), esta lahetys aina kokonaan capture-vaiheessa. */
    document.addEventListener(
      'submit',
      function (e) {
        var form = e.target;
        if (!form || typeof form.getAttribute !== 'function') return;
        var action = form.getAttribute('action') || '';
        var type = form.getAttribute('data-type') || '';
        if (type === 'add-to-cart-form' || /\/cart(\/|$|\?)/.test(action) || /\/checkout/.test(action)) {
          e.preventDefault();
          e.stopImmediatePropagation();
        }
      },
      true
    );

    document.addEventListener('click', function (e) {
      var cartOrCheckoutLink = e.target.closest('a[href="' + getCartUrl() + '"], a[href*="/checkout"]');
      if (cartOrCheckoutLink) {
        e.preventDefault();
        return;
      }

      var toivekoriBtn = e.target.closest('.kj-qr-toivekori-btn');
      if (toivekoriBtn) {
        e.preventDefault();
        toggleItemFromButton(toivekoriBtn);
        return;
      }

      /* KJ QR: tuotekortin otsikko/kuva EI ENAA kaappaa klikkausta —
         se vie normaalisti tuotteen omalle sivulle, aivan kuten
         tavallisessakin verkkokaupassa. Tuotesivulla oikea "Lisaa
         ostoskoriin" on jo korvattu Toivekoriin-painikkeella (tai
         viestilla, jos tuote ei ole noudettavissa) — ks.
         insertProductPageNotice(). Ainoa tapa lisata Toivekoriin
         suoraan kokoelmasivulta on se pieni oma ♥-painike kortin
         paalla (kasitelty jo yllä .kj-qr-toivekori-btn -haaralla). */

      var removeBtn = e.target.closest('[data-kj-remove-id]');
      if (removeBtn) {
        e.preventDefault();
        removeItemById(removeBtn.getAttribute('data-kj-remove-id'));
        return;
      }

      if (e.target.closest('#KjQrFab')) {
        e.preventDefault();
        openDrawer();
        return;
      }

      if (e.target.closest('#KjQrDrawerClose') || e.target === document.getElementById('KjQrDrawerOverlay')) {
        e.preventDefault();
        closeDrawer();
        return;
      }

      if (e.target.closest('#KjQrGotoForm')) {
        e.preventDefault();
        showFormView();
        return;
      }

      if (e.target.closest('#KjQrBackToList')) {
        e.preventDefault();
        showListView();
        return;
      }

      var exitLink = e.target.closest('.kj-qr-exit-link');
      if (exitLink) {
        safeRemove(window.sessionStorage, STORAGE_PICKUP);
        /* linkin oma navigointi jatkuu normaalisti */
      }
    });

    var form = document.getElementById('KjQrForm');
    if (form) {
      form.addEventListener('submit', function (e) {
        var ok = validateAndFillForm(form);
        if (!ok) {
          e.preventDefault();
        }
      });
    }

    /* KJ QR: asiakas voi vaihtaa noutopaikan lomakkeessa riippumatta
       siita, kumman QR-koodin han skannasi — esim. Combon telineella
       skannannut voi silti valita saman paivan noudon Sepankylasta,
       jos se sopii paremmin. */
    document.addEventListener('change', function (e) {
      var radio = e.target.closest('input[name="kjPickupChoice"]');
      if (!radio) return;
      if (VALID_PICKUPS.indexOf(radio.value) === -1) return;
      pickup = radio.value;
      safeSet(window.sessionStorage, STORAGE_PICKUP, pickup);
      applyPickupUI();
    });
  }
})();
